const {
	trackGtm,
	trackDownload,
	trackGtm4,
} = require('../../../../js/functions');

module.exports = {
	init() {
		this.title = this.root.querySelector('.sustainability--title');
		this.link = this.root.querySelector('.sustainability--link');
		this.isDownload = this.link.dataset.download;
		this.initEvents();
		this.link.addEventListener('click', () => {
			trackGtm4({
				event: 'GA4_event_c_cta',
				widget_name: 'V3-Article highlight',
				widget_title: this.title.innerHTML,
				link_text: this.link.innerHTML,
				link_url: this.link.href,
				button_type: '',
			});
		});
	},
	initEvents() {
		this.root.addEventListener('click', this.gtmTracking.bind(this));
	},
	gtmTracking() {
		const textTitle = this.title.textContent;
		const linkTitle = this.link.textContent;
		const { href } = this.link;
		if (this.isDownload === 'true') {
			trackDownload(textTitle, href);
		} else {
			trackGtm({
				eventCategory: 'cta',
				eventAction: 'button',
				eventLabel: `${textTitle} | ${linkTitle} | ${href}`,
			});
		}
	},
};
